<template>
  <read_layout :title="book.cnTitle">
    <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
    <div :class="full ? 'fullscreen' : 'pager'">
      <div class="sizebar">
        <vueslider v-model="size" :min="20" />
      </div>
      <span class="actable" @click="pre">
        <span :class="haspre || 'hidden'" class="iconfont iconpre"></span>
      </span>
      <!-- <template v-if="book.format == 'Jpeg'"> -->
      <image-loader
        @loaded="initscale"
        id="cover"
        @dblclick="swithFull"
        class="magcontent"
        :src="cover"
        :height="coverheight"
        width="auto"
      />
      <!-- </template> -->
      <!-- <template v-else-if="book.format == 'PDF'">
        <div @dblclick="swithFull" class="magcontent">
          <pdf
            :src="book.filePath"
            :page="pageNo"
            :scale="full ? size / 100 : 'page-height'"
            :text="false"
            @error="pdferr"
          >
          </pdf>
        </div>
      </template>
      <template v-else-if="book.format == 'EPub'">
        <div class="magcontent epub">
          <div id="epubrender" ref="epubrender"></div>
          <div class="mark" @dblclick="swithFull"></div>
        </div>
      </template> -->
      <span class="actable" @click="next">
        <span :class="hasnext || 'hidden'" class="iconfont iconnext"></span>
      </span>
    </div>
    <div class="showpager">{{ pageNo }}/{{ book.pageNumber }}</div>
  </read_layout>
</template>

<script>
import ReadLayout from "../components/_layout/bookread_layout";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { cacheBook, getCacheBook } from "../libs/utils";
import { get, head } from "../libs/bookRequest";
import { bookAPI } from "../libs/consts";
// import pdfvuer from "pdfvuer";
import iziToast from "izitoast";
// import Epub from "epubjs";
export default {
  name: "ReadLayout",
  components: {
    read_layout: ReadLayout,
    vueslider: VueSlider,
    // pdf: pdfvuer,
  },
  data() {
    return {
      pdfdata: undefined,
      book: {},
      totalPage: 0,
      issueData: {},
      current: { cover: "" },
      coverInd: 0,
      cover: "",
      cache: {},
      loading: false,
      showsilder: false,
      full: false,
      scale: 0,
      size: 20,
      pageNo: 1,
    };
  },
  computed: {
    isbn() {
      return this.$route.params.isbn;
    },
    hasnext() {
      if (this.pageNo == -1) return true;
      const maxPage =
        this.current.pages == undefined ? 0 : this.current.pages.length;
      return this.totalPage > this.pageNo + 1 || maxPage > this.coverInd + 1;
    },
    haspre() {
      return this.pageNo > 1;
    },
    coverheight() {
      if (this.full) {
        const ele = document.querySelector("#cover>img");
        return Math.round((ele.naturalHeight * this.size) / 100) + "px";
      } else {
        return undefined;
      }
    },
  },
  async created() {
    await this.loadData();
  },
  methods: {
    initscale() {
      const ele = document.querySelector("#cover>img");
      this.scale = ele.height / ele.naturalHeight;
      this.size = Math.round(this.scale * 100);
    },
    swithFull() {
      this.full = !this.full;
      // if (this.book.format == "EPub") {
      //   if (this.full)
      //     this.$refs.epubrender.style.transform = `scale(${
      //       1 + this.size / 100
      //     })`;
      //   else this.$refs.epubrender.style.transform = `scale(1)`;
      // }
    },
    loadData: async function () {
      let data = getCacheBook(this.isbn);
      if (data == undefined || data === "{}") {
        this.loading = true;
        data = await get(bookAPI.book.info(this.isbn));
        cacheBook(this.isbn, data);
        this.loading = false;
      }
      this.book = data;
      this.cover = data.coverPath;
      this.totalPage = data.pageNumber;
      this.pageNo = 1;

      head(bookAPI.book.page(this.book.isbn, this.pageNo)).then();
      // var self = this;
      // if (data.format == "PDF") {
      //   self.loading = true;
      //   self.pdfdata = pdfvuer.createLoadingTask(data.filePath);
      //   self.pdfdata.then((pdf) => {
      //     self.totalPage = pdf.numPages;
      //     this.loading = false;
      //     this.size = 60;
      //   });
      // } else if (data.format == "EPub") {
      //   self.loading = true;
      //   let epubboook = new Epub();
      //   //https://booku-obj.oss-cn-hongkong.aliyuncs.com/1人類智庫/9789865855956.epub
      //   epubboook.open("/9789865855956.epub").then(() => {
      //     self.rendition = epubboook.renderTo("epubrender", {
      //       width: 500, //self.$refs.epubrender.clientWidth,
      //       height: 700, // self.$refs.epubrender.clientHeight,
      //     });
      //     self.rendition.themes.override("background-color", "#fff", true);
      //     self.loading = false;
      //     self.rendition.display();
      //   });
      // this.nav = epubboook.renderTo("epubrender");
      // this.nav.display();
      // }
    },
    pdferr(err) {
      iziToast.error({
        title: "error",
        message: err.message,
        close: false,
        drag: false,
      });
      this.loading = false;
    },
    pre() {
      if (!this.haspre || this.loading) return;
      this.pageNo -= 1;
      // if (this.book.format == "Jpeg") {
      this.cover =
        this.book.jpegPath + (this.pageNo + "").padStart(3, "0") + ".jpg";
      // } else if (this.book.format == "EPub") {
      //   this.rendition.prev();
      // }
      head(bookAPI.book.page(this.book.isbn, this.pageNo)).then();
    },
    next() {
      if (this.loading || !this.hasnext) return;
      this.pageNo += 1;
      // if (this.book.format == "Jpeg") {
      this.cover =
        this.book.jpegPath + (this.pageNo + "").padStart(3, "0") + ".jpg";
      // } else if (this.book.format == "EPub") {
      //   this.rendition.next();
      // }
      head(bookAPI.book.page(this.book.isbn, this.pageNo)).then();
    },
    switchSilder() {
      this.showsilder = !this.showsilder;
    },
  },
  watch: {
    size(val) {
      if (this.book.format == "EPub") {
        this.$refs.epubrender.style.transform = `scale(${1 + val / 100})`;
      }
    },
  },
};
</script>

<style scoped>
.pager {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: calc(100vh - 0.8rem);
  /* margin-top: 0.8rem; */
  transition: all 0.3s ease-out;
}

.iconfont {
  color: #777777;
  font-size: 0.6rem;
}

.pager .actable {
  /* width: 0.33rem; */
  margin: 0 0.4rem;
}

.magcontent {
  /* min-width: 4rem;
  min-height: 6rem;*/
  max-width: 80vw;
  height: 100%;
  box-shadow: 0px 0px 5px 0px rgba(132, 132, 132, 0.5);
}

.epub {
  height: 700px;
  width: 500px;
  position: relative;
}

.fullscreen .epub {
  height: 700px;
  width: 500px;
  position: relative;
  margin: 0 auto;
}

.page {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.sizebar {
  display: none;
}

.fullscreen {
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 13;
  margin: 0;
  max-width: 100vw;
  background-color: #777777;
  transition: all 0.3s ease-in;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  text-align: center;
  display: block;
}

.fullscreen .iconfont {
  color: #fff;
  position: fixed;
  top: calc(50vh - 0.3rem);
  z-index: 20;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 0.4rem;
  line-height: 2;
}

.fullscreen .iconpre {
  left: 0.4rem;
}

.fullscreen .iconnext {
  right: 0.4rem;
}

.fullscreen .magcontent {
  max-width: none;
}

.fullscreen .sizebar {
  position: fixed;
  bottom: 20px;
  /* right: calc(100vh - 50px); */
  right: 20px;
  display: inline-block;
  width: 100px;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 10px;
  padding: 0 8px;
  z-index: 99;
}

.showpager {
  position: fixed;
  bottom: 0px;
  right: 20px;
  font-size: 0.2rem;
  color: #fff;
  padding: 0 8px;
  z-index: 99;
}

.hidden {
  visibility: hidden;
}

.mark {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

html {
  background-color: #777777;
}
</style>

<style>
#viewerContainer .page {
  margin: 0 auto;
}
</style>